import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { TreePine, Footprints, ListChecks, CalendarClock, Home } from "lucide-react";
import EstateProperties from "./EstateProperties";
import EstateWalkthrough from "./EstateWalkthrough";
import EstateTasks from "./EstateTasks";
import EstateSchedules from "./EstateSchedules";

const TABS = [
  { id: "walkthrough", label: "Walkthrough", icon: Footprints },
  { id: "tasks", label: "Tasks", icon: ListChecks },
  { id: "schedules", label: "Schedules", icon: CalendarClock },
  { id: "properties", label: "Properties", icon: Home },
];

export default function EstateHome() {
  const { user } = useAuth();
  const isManager = ["admin", "supervisor"].includes(user.role);
  const [tab, setTab] = useState("walkthrough");
  const [properties, setProperties] = useState([]);
  const [employees, setEmployees] = useState([]);

  const loadProps = () => api.get("/estate/properties").then(({ data }) => setProperties(data));
  useEffect(() => {
    loadProps();
    api.get("/employees").then(({ data }) => setEmployees(data.filter((e) => e.active)));
  }, []);

  return (
    <div className="space-y-5" data-testid="estate-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight flex items-center gap-3" style={{ fontFamily: "'Fraunces', serif" }}>
          <TreePine size={36} className="text-[#7C9673]" /> Estate Care
        </h1>
        <p className="text-stone-500 text-sm mt-1">Landscaping & estate maintenance — walk properties, capture tasks, schedule crews</p>
      </div>

      <div className="flex bg-white border border-stone-200 w-fit overflow-x-auto max-w-full">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`estate-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`px-4 py-2.5 text-xs font-bold uppercase whitespace-nowrap flex items-center gap-1.5 ${tab === t.id ? "bg-[#1F3D34] text-white" : "text-stone-600"}`}>
            <t.icon size={14} /> {t.label}
          </button>
        ))}
      </div>

      {tab === "walkthrough" && <EstateWalkthrough properties={properties} employees={employees} />}
      {tab === "tasks" && <EstateTasks properties={properties} employees={employees} isManager={isManager} />}
      {tab === "schedules" && <EstateSchedules properties={properties} employees={employees} isManager={isManager} />}
      {tab === "properties" && <EstateProperties properties={properties} onChange={loadProps} isManager={isManager} />}
    </div>
  );
}
